export enum MailingAddressOption {
  PRIMARY = 'PRIMARY',
  NEW = 'NEW',
}

export interface IUpdatePaymentDTO {
  paymentAddress: string;
  paymentDetail: string;
}
